import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import ProductItem from '../ProductItem'
import { recommendMobx, themeMobx, decorationMobx } from '@mobxStore'
import { cartMobx, menuMobx, restaurantConfig } from 'restaurant'
import './index.scss'

const RecommendProducts: React.FC = () => {
  const { homeRecommendProducts } = recommendMobx
  const { cartResult } = cartMobx
  const { products } = menuMobx
  const { recommendProductsStatus, recommendProductsName, showCount, smartOrCustom } = themeMobx.data.recommendProducts
  // 智能推荐显示数量根据showCount，手动推荐根据返回数量
  const sliceCount = smartOrCustom ? 5 : showCount
  return (
    <>
      {
        products.length && // 如果没有菜单餐品，推荐不展示
          (recommendProductsStatus && homeRecommendProducts.length && restaurantConfig.displayMode === 'waterfall') // 开启推荐餐品且推荐餐品有数据并且是瀑布流
          ? (
            <div className='recommend-products'>
              <p className='title'>{recommendProductsName || i18n.t('menu.recommend')}</p>
              <div className='recommend-list'>
                {
                  homeRecommendProducts.length ? (
                    homeRecommendProducts.slice(0, sliceCount).map(product => {
                      const count = cartResult?.productNoToCntMap?.[product.no] || 0
                      return (
                        <ProductItem
                          key={`recomment-${product.no}`}
                          type='recommend'
                          product={product}
                          count={count}
                          lazy={false}
                          mealDecorates={decorationMobx.mealDecorates}
                        />
                      )
                    })
                  ) : null
                }
              </div>
            </div>
          ) : null
      }
    </>
  )
}

export default observer(RecommendProducts)
